module.exports = __webpack_public_path__ + "img/resultT.02190e81.png";